import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Youtube(props: Partial<SVGProps<any>> & {dark?:boolean}) {
  const { dark, ...spreadProps} = props;
  return (
    <div {...spreadProps} className={twMerge('grid place-items-center',spreadProps.className)}>

<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M15.975 0.375047C16.7625 0.625047 17.325 1.25 17.55 2.12505C18 3.75 18 7 18 7C18 7 18 10.25 17.6625 11.875C17.4375 12.75 16.875 13.375 16.0875 13.625C14.625 14 9 14 9 14C9 14 3.26246 14 1.91246 13.625C1.125 13.375 0.562543 12.75 0.337543 11.875C-1.78814e-07 10.25 0 7 0 7C0 7 -1.53269e-07 3.75 0.225 2.12505C0.45 1.25 1.01254 0.625047 1.8 0.375047C3.26254 -1.98682e-07 8.88746 0 8.88746 0C8.88746 0 14.625 -1.98682e-07 15.975 0.375047ZM7.19991 4.00029L11.9249 7.00029L7.19991 10.0003V4.00029Z" className={twMerge("fill-[#212021] dark:fill-white", dark && 'fill-white')}/>
</svg>
    </div>
  )
}